import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray } from '@angular/forms';

import { filter, map } from 'rxjs/operators';

import { Attachment, Reference } from '@library/common/models';
import { CountriesService, EnumsService } from '@library/core/services';
import { AttachmentService } from '@library/modules/attachment';

import { ShipmentDetailsService } from './shipment-details.service';
import { QuotationDetailsService } from '@library/modules/api-services';
import { forkJoin, Observable } from 'rxjs';
import { IGenericType } from '@library/common/generictype';

@Component({
   selector: 'lib-shipment-details',
   inputs: [ 'hawb' ],
   templateUrl: './details.component.html',
   styleUrls: [ './details.component.scss' ],
})
export class ShipmentDetailsComponent implements OnInit  {

   @Input()
   public mode = 'shipment';

   @Input()
   public hawb: string;

   @ViewChild('textContent') textContent!: ElementRef;

   allowNewAttachments = false;

   attachmentUpdates: FormArray = new FormArray( [] );

   expanded: boolean = false;
   showToggle: boolean = false;
   remainingAccessorials: IGenericType;

   quoteStatus: IGenericType;

   constructor(
      public countries: CountriesService,
      public enums: EnumsService,
      public details: ShipmentDetailsService,
      public quoteDetails: QuotationDetailsService,

      private attachmentService: AttachmentService,
      private route: ActivatedRoute,
   ) { }

   ngOnInit() {
      this.route.data.pipe( filter( data => data?.allowNewAttachments ))
         .subscribe( data => this.allowNewAttachments = data?.allowNewAttachments );
   }

   get allItems() {
      const l: Observable<any> = this.mode === 'shipment' ?
      this.details.load( this.hawb ) : this.quoteDetails.load( this.hawb );
      return l.pipe(
            map( s => s?.calculator ?? ( s['containers'] ?? [] )
               .filter( c => c?.items?.length )
               .reduce(( a, c ) => [ ...a, ...c?.items ], [] )),
         );
   }

   getBillingPartyRef( shipment: IGenericType ): Reference {
      return shipment?.references?.filter( r => r.party === (shipment?.billingparty ?? shipment?.billingParty) )[0];
   }

   getSortedStatusesById(statuses: any[]): any[] {
      if (!statuses) return [];
      
      return [...statuses].sort((a, b) => a.orderingId - b.orderingId);
   }

   saveAttachments( hawb: string, attachments: Attachment[] ): void {
      this.attachmentService.savingState = 'saving';

      forkJoin( attachments.map(( attch ) => this.attachmentService.uploadAttachment({ hawb, attachments: [attch] })))
         .subscribe( _ => {
            this.attachmentService.savingState = 'show';

            this.attachmentUpdates.clear();
            this.details.reset();
         });
   }

   saveQuoteAttachments( quoteNumber: string, attachments: Attachment[] ): void {
      this.attachmentService.savingState = 'saving';

      forkJoin( attachments.map(( attch ) => this.attachmentService.uploadAttachment({ quoteNumber, attachments: [attch] })))
         .subscribe( _ => {
            this.attachmentService.savingState = 'show';
0
            this.attachmentUpdates.clear();
            this.quoteDetails.reset();
         });
   }

   getAccessorial(accessorials: IGenericType, expand = false){
      accessorials.sort(( a, b ) => {
         const descA = a.description.toLowerCase();
         const descB = b.description.toLowerCase();
         return descA < descB ? -1 : descA > descB ? 1 : 0;
      });
      const accessorialsLimit = 8;
      this.showToggle = accessorials.length > accessorialsLimit;
      this.remainingAccessorials = accessorials.length - accessorialsLimit;

      const filteredAccessorials = accessorials
         .filter((_,i)=> expand || i < accessorialsLimit)
         .map(x=> x.description ).join(', ');

      return filteredAccessorials;
   }
}
